import { Injectable } from '@angular/core';
import { LegalPaper } from '@models/center/legal-paper/legal-paper';
import { EndpointParams } from '@models/utils/endpoint-params';
import { HttpService } from '@services/http.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CenterLegalService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'center', version: 1 };

    search(idCenter: number): Observable<LegalPaper> {
        return this.get(`legalpaper/${idCenter}`, this.defaultEndpointParams);
    }
}
